import { useSelector } from 'react-redux';
import { selectSchema } from './store/selectors';
import { CWState } from './store/slice';
import { Fragment, useState } from 'react';
import TreeNav from './tree/TreeNav';
import NoResults from '../../../components/empty-state/NoResults';
import FormActions from './layout/FormActions';
import Property from './layout/Property';
import ErrorBoundary from '../../../ErrorBoundary';
import { Calculation } from '../../../types/worksheet';
import SchemaSources from './SchemaSources';
import SchemaTabs from './SchemaTabs';

type SchemaFormProps = {
    worksheetId: string;
    calculation: Calculation;
    name: string;
};

function SchemaForm({ worksheetId, calculation, name }: SchemaFormProps): JSX.Element {
    const [search, setSearch] = useState<string | undefined>();
    const schema = useSelector((state: { schema: CWState }) => selectSchema({ state, filter: 'all', search: search }));
    const selectedTab = useSelector((state: { schema: CWState }) => state.schema.currentTab);

    if (!schema || !schema.properties) {
        return (
            <div>
                <p>Unable to load schema. Please reload the page.</p>
            </div>
        );
    }

    return (
        <div className="flex w-full gap-8">
            <div className="flex flex-col gap-4 grow min-w-0">
                <FormActions worksheetId={worksheetId} calculation={calculation} name={name} search={search} onSearch={setSearch} />
                <ErrorBoundary>
                    <SchemaSources sources={schema.sources ?? []} />
                    <SchemaTabs />
                    {Object.entries(schema.properties).length > 0 ? (
                        <div className="flex flex-col pb-60 min-w-0 gap-8">
                            {Object.entries(schema.properties)
                                .sort((a, b) => (a[1].order > b[1].order ? 1 : -1))
                                .map(([, value]) => {
                                    if (!selectedTab) {
                                        return <Property key={value.id} value={value} />;
                                    }
                                    if (selectedTab === value.id) {
                                        return <Property key={value.id} value={value} />;
                                    }
                                    return <Fragment key={value.id}></Fragment>;
                                })}
                        </div>
                    ) : (
                        <div className="mt-16">
                            <NoResults search={search || ''} />
                        </div>
                    )}
                </ErrorBoundary>
            </div>
            <div className="shrink-0">
                <TreeNav />
            </div>
        </div>
    );
}

export default SchemaForm;
